// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__n+oYF","innerInput":"Switch_innerInput__e6I5P","left":"Switch_left__0ewYZ","right":"Switch_right__iRPaC"};